import { ReactNode } from 'react'

import { useAppSelector } from '~/redux/hooks'
import { selectHasStartedQuiz } from '~/bootcamp/slices/bootcamp-quiz.slice'

interface Props {
  showModal: boolean
  children: ReactNode
}

const BossMobileModal = ({ showModal, children }: Props): React.ReactElement => {
  const hasStartedQuiz = useAppSelector(selectHasStartedQuiz)

  const visibilityClass = showModal
    ? 'absolute inset-0 bg-white z-40 flex flex-col rounded-b'
    : `${!hasStartedQuiz ? 'flex-1' : ''}`

  return (
    <div className={visibilityClass}>
      <div className="flex flex-1 justify-center">{children}</div>
    </div>
  )
}

export default BossMobileModal
